import { DARK_MODE } from "./dark-mode.types";

export const toggleDarkMode = () => ({ type: DARK_MODE });
